import { configureStore } from "@reduxjs/toolkit";
import homeSlice from "./homeSlice";
import hotelSlice from "./hotelSlice";
import packageSlice from "./packageSlice";
import experienceSlice from "./experienceSlice";
import contactSlice from "./contactSlice";
import ticketSlice from "./ticketSlice";
import { cartReducer } from "./cartSlice";

const store = configureStore({
  reducer: {
    home: homeSlice,
    hotel: hotelSlice,
    package: packageSlice,
    experience: experienceSlice,
    contact: contactSlice,
    ticket: ticketSlice,
    cart: cartReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
